import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Option,
    Select,
    Typography,
} from "@material-tailwind/react";
import { FieldArray, Form, Formik } from "formik";
import FormikCheckbox from "components/form/formik-checkbox";
import Trademark from "components/Trademark";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";

export default function ThemeAnswersDialog({
    showThemeAnswersDialog,
    setShowThemeAnswersDialog,
    themeEdit,
    handleThemeAnswersSubmit,
    validationSchemaThemeAnswers,
    themeAnswersThemesState,
    setThemeAnswersThemesState,
    surveyQuestions,
    surveyRespondentAnswers,
    modQShown,
    setModQShown,
    themeAnswers,
}) {
    const handleClose = () => {
        setShowThemeAnswersDialog((showThemeAnswersDialog) => !showThemeAnswersDialog);
    };
    return (
        <Dialog
            open={showThemeAnswersDialog}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">Apply Theme</DialogHeader>
            <Formik
                initialValues={{
                    theme: themeEdit?.id || 0,
                    answers_preset:
                        themeAnswers?.theme_preset_answers.map(
                            (e) => e.preset_answer_id,
                        ) || [],
                    answers_custom:
                        themeAnswers?.theme_respondent_answers.map(
                            (e) => e.respondent_answer_id,
                        ) || [],
                }}
                onSubmit={handleThemeAnswersSubmit}
                validationSchema={validationSchemaThemeAnswers}
                enableReinitialize
            >
                {({ isValid, dirty, values }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <Typography className="px-4 pt-2 font-body">
                                Apply this theme to any/all answers to a
                                particular question. First choose an answer from
                                either Gobby
                                <Trademark /> Response or a preset answers
                                question from the list
                            </Typography>
                            <div className="flex flex-row-reverse mb-4">
                                <Button
                                    onClick={() =>
                                        setThemeAnswersThemesState("preset")
                                    }
                                    color={
                                        themeAnswersThemesState === "response"
                                            ? "white"
                                            : "white"
                                    }
                                    className="btn btn--secondary ml-2"
                                    variant="filled"
                                >
                                    Preset Answers
                                </Button>
                                {!!surveyRespondentAnswers && (
                                    <Button
                                        onClick={() =>
                                            setThemeAnswersThemesState(
                                                "response",
                                            )
                                        }
                                        color={
                                            themeAnswersThemesState ===
                                            "response"
                                                ? "white"
                                                : "white"
                                        }
                                        className="btn btn--secondary"
                                        variant="filled"
                                    >
                                        Gobby
                                        <Trademark /> Response
                                    </Button>
                                )}
                            </div>
                            {!!surveyQuestions && (
                                <Select
                                    className="bg-white"
                                    label="Select a question from the list"
                                    value={modQShown?.toString()}
                                    onChange={(e) => {
                                        const indexInt = parseInt(e);
                                        setModQShown(indexInt);
                                    }}
                                    menuProps={{
                                        className:
                                            "max-h-[calc(100%+7rem)] overflow-y-auto",
                                    }}
                                >
                                    {surveyQuestions.map((q, index) => (
                                        <Option key={q.id} value={`${index}`}>
                                            Question {q.position}: {q.text}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                            {!!(themeAnswersThemesState === "preset") && (
                                <FieldArray name="answers_preset">
                                    {({ push, remove }) => (
                                        <div className="p-2 rounded-lg bg-white mt-2 w-full">
                                            <GobbyTable>
                                                <GobbyTableHead>
                                                    <GobbyTableRow>
                                                        <GobbyTableHeader className="w-5/6">
                                                            Preset Response
                                                        </GobbyTableHeader>
                                                        <GobbyTableHeader className="w-1/6">
                                                            Theme
                                                        </GobbyTableHeader>
                                                    </GobbyTableRow>
                                                </GobbyTableHead>
                                                <GobbyTableBody>
                                                    {surveyQuestions[
                                                        modQShown
                                                    ]?.preset_answers.map(
                                                        (answer) => (
                                                            <GobbyTableRow
                                                                key={answer.id}
                                                            >
                                                                <GobbyTableCell className="">
                                                                    {
                                                                        answer.text
                                                                    }
                                                                </GobbyTableCell>
                                                                <GobbyTableCell className="text-right md:pr-4">
                                                                    <FormikCheckbox
                                                                        name="answers_preset"
                                                                        type="checkbox"
                                                                        value={
                                                                            answer.id
                                                                        }
                                                                        checked={values.answers_preset.includes(
                                                                            answer.id,
                                                                        )}
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            if (
                                                                                e
                                                                                    .target
                                                                                    .checked
                                                                            ) {
                                                                                push(
                                                                                    answer.id,
                                                                                );
                                                                            } else {
                                                                                const idx =
                                                                                    values.answers_preset.indexOf(
                                                                                        answer.id,
                                                                                    );
                                                                                remove(
                                                                                    idx,
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                </GobbyTableCell>
                                                            </GobbyTableRow>
                                                        ),
                                                    )}
                                                </GobbyTableBody>
                                            </GobbyTable>
                                        </div>
                                    )}
                                </FieldArray>
                            )}
                            {!!(themeAnswersThemesState === "response") && (
                                <FieldArray name="answers_custom">
                                    {({ push, remove }) => (
                                        <div className="p-2 rounded-lg bg-white mt-2 w-full">
                                            <GobbyTable>
                                                <GobbyTableHead className="">
                                                    <GobbyTableRow>
                                                        <GobbyTableHeader className="w-5/6">
                                                            Gobby
                                                            <Trademark />{" "}
                                                            Response
                                                        </GobbyTableHeader>
                                                        <GobbyTableHeader className="w-1/6">
                                                            Theme
                                                        </GobbyTableHeader>
                                                    </GobbyTableRow>
                                                </GobbyTableHead>
                                                <GobbyTableBody>
                                                    {surveyRespondentAnswers?.[
                                                        modQShown
                                                    ]?.respondent_answers.map(
                                                        (answer) => (
                                                            <GobbyTableRow
                                                                key={answer.id}
                                                            >
                                                                <GobbyTableCell className="">
                                                                    {
                                                                        answer.text
                                                                    }
                                                                </GobbyTableCell>
                                                                <GobbyTableCell className="text-right md:pr-4">
                                                                    <FormikCheckbox
                                                                        name="answers_custom"
                                                                        type="checkbox"
                                                                        value={
                                                                            answer.id
                                                                        }
                                                                        checked={values.answers_custom.includes(
                                                                            answer.id,
                                                                        )}
                                                                        onChange={(
                                                                            e,
                                                                        ) => {
                                                                            if (
                                                                                e
                                                                                    .target
                                                                                    .checked
                                                                            ) {
                                                                                push(
                                                                                    answer.id,
                                                                                );
                                                                            } else {
                                                                                const idx =
                                                                                    values.answers_custom.indexOf(
                                                                                        answer.id,
                                                                                    );
                                                                                remove(
                                                                                    idx,
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                </GobbyTableCell>
                                                            </GobbyTableRow>
                                                        ),
                                                    )}
                                                </GobbyTableBody>
                                            </GobbyTable>
                                        </div>
                                    )}
                                </FieldArray>
                            )}
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <div className="">
                                <Button
                                    type="button"
                                    className="btn btn--secondary mr-2"
                                    variant="filled"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={!(isValid && dirty)}
                                    onClick={handleClose}
                                    className="btn btn--primary"
                                    variant="filled"
                                >
                                    Save
                                </Button>
                            </div>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
